import { createFileRoute } from "@tanstack/react-router";

import { AdminAuditPage } from "@/components/admin/AdminAuditPage";

export const Route = createFileRoute("/administrator/audit")({
  head: () => ({ meta: [{ title: "Audit log · GENRL Admin" }] }),
  component: AdminAuditPage,
});
